export default function formatDuration(duration) {
  const minutes = Math.floor(duration / 60);
  const remainingSeconds = Math.floor(duration % 60);

  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
}
